import styles from './Sobre.module.scss';

export const Sobre = () => {

  /*
    Input
  */

  return (
    <div className={styles.divFrasePromocoes}>
      <div>
        <p className={styles.frasePromocoes}>
            Fique por dentro de todas as promoções!
        </p>
      </div>
      <div className={styles.containerPromocoes}>
        <div>
          <img src='/icons/mail.png' alt="Logo" width={32} />
        </div>
        <div>
          <input
            type="text"
            id="custom-input"
            className={styles.inputInscrever}
            placeholder="Digite seu e-mail"
          />
          <button className={styles.botaoInscrever}>INSCREVE-SE</button>
        </div>
        
      </div>
      <div className={styles.containerSobre}>
        <p className={styles.frase}>
        FALE COM A GENTE!
        </p>
        <p className={styles.frase} >
        Av. Romulado Vilani, 268 - Jardim Ipanema
        </p>
        <p className={styles.frase}  >
        São Carlos - SP | CEP: 13563-651
        </p>
        <a className={styles.frase} href='mailto:contact@market.com'>
        Email: contact@market.com
        </a>
        <p className={styles.frase}  >
        Telefone: 16 3363.6363 | 16 3364.6464
        </p>
      </div>

      <div className={styles.containerSobre}>
        <a className={styles.frase}>
        SOBRE
        </a>
        <a className={styles.frase} href='#'>
        Termos de Uso
        </a>
        <a className={styles.frase}  href='#'>
        Política de Privacidade
        </a>
      </div>

      <div className={styles.containerSobre}>
        <a className={styles.frase}>
          SERVIÇOS
        </a>
        <a className={styles.frase}  href='#'>
        Minha Conta
        </a>
        <a className={styles.frase} href='#'>
        Entrega
        </a>
        <a className={styles.frase} href='#'>
        Contate-nos
        </a>
      </div>

      <div className={styles.containerSobre}>
        <p className={styles.frase}>
        PAGAMENTO
        </p>
        <a className={styles.frase} href='#'>
        Termos de Uso
        </a>
        <a className={styles.frase} href='#'>
        Meio de Pagamento
        </a>
        <a className={styles.frase} href='#'>
        Regra para Devolução
        </a>
      </div>
    </div>
  );

};